import { render, staticRenderFns } from "./shouldReceiptInfo.vue?vue&type=template&id=5a4aa817&scoped=true"
import script from "./shouldReceiptInfo.vue?vue&type=script&lang=js"
export * from "./shouldReceiptInfo.vue?vue&type=script&lang=js"
import style0 from "./shouldReceiptInfo.vue?vue&type=style&index=0&id=5a4aa817&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4aa817",
  null
  
)

export default component.exports